<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <SiruiSearch
      ref="searchRef"
      :query="queryData"
      :columns="columns"
      :isQueryPanel="true"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchTrigger"
      @changeMethod="changeMethod"
    ></SiruiSearch>
    <div class="result-table">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :cellClick="cellClick"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :cellStyle="cellStyle"
        :columns="tableColumns"
        :footerMethod="footerMethodTotal"
        :showFooter="true"
        @chooseClick="chooseClick"
        @handleSelectionChange="handleSelectionChange"
        @handleSizeChange="() => getList()"
        @handleCurrentChange="() => getList()"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </SiruiTable>
    </div>
  </el-card>
</template>

<script>
  import { debtSearchColumns, debtTableColumns } from './columns';
  import ReportMixin from './mixins/reportMixin';
  export default {
    name: 'debt',
    mixins: [ReportMixin],
    data() {
      return {
        loading: false,
        menuButtonList: [],
        tableData: [],
        selectedItems: [],
        queryData: {
          contractCompanyNo: null,
          contractDepartmentNo: null,
          customerName: null,
          expenseType: [],
        },
        footerTotalCols: {
          amount: [
            'facadeRent',
            'freightYardRent',
            'venueRent',
            'propertyManagementServiceFee',
            'utilityBills',
            'sanitationFees',
            'otherCosts',
            'accumulatedReceived',
            'totalAmountOwed',
          ],
          quantity: [],
        },
      };
    },
    computed: {
      columns() {
        return debtSearchColumns(this);
      },
      tableColumns() {
        return debtTableColumns();
      },
    },
    mounted() {
      this.queryData.contractCompanyNo = this.userInfo.companyCode;
      this.department(this.userInfo.companyCode);
      this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
      this.getList();
      this.getButtonList();
    },
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
      async resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData.contractCompanyNo = this.userInfo.companyCode;
        await this.department(this.userInfo.companyCode);
        this.queryData.contractDepartmentNo = this.userInfo.departmentCode;
        // this.companyName = this.userInfo.companyName;
        // this.departmentName = this.userInfo.departmentName;
        this.getList();
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getList();
      },
      async getList() {
        let params = { ...this.queryData };
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params = this.filterEmpty(params);
        this.loading = true;
        const { data } = await this.$axios.post(
          '/property/property/receivableDetail/pageSummary',
          params
        );
        if (data && data.data && data.code == 0) {
          this.tableData = data.data.records || [];
          // this.copyTableData = JSON.parse(JSON.stringify(data.data.records));
          // let list = this.tableStructure(data.data.records);
          // this.tableData = list;

          this.$refs.siruiTable.setPageTotal(data.data.total);
          this.$refs.siruiTable.setPageSize(data.data.size);
        } else {
          this.$message.error(data.msg);
        }
        this.loading = false;
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
      },
      // 表格上面的按钮
      async chooseClick(type) {
        switch (type) {
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          default:
            break;
        }
      },
      cellStyle({ column }) {
        if (column.property == 'customerName') {
          return {
            color: '#009fcc',
          };
        }
      },
      async handleExport() {
        let empty = !this.selectedItems || !this.selectedItems.length;
        if (empty) {
          this.$message.error('请选择数据！');
          return;
        }
        let api = '/property/property/receivableDetail/exportSummary';
        const customerNameList = this.selectedItems.map((v) => v.customerName);
        await this.$axios.post(api, { customerNameList }).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      cellClick(val) {
        if (val.column?.property == 'customerName') {
          const params = { ...this.queryData };
          params.expenseType1 = params.expenseType;
          delete params.expenseType;
          params.customerName = val.row.customerName;
          this.$router.push({
            name: `detailAccount1`,
            params,
          });
        }
      },
    },
  };
</script>

<style scoped></style>
